import React, { useEffect } from "react";
import Changepassword from "../components/Changepassword/changepassword";
import Navbar from "../components/Navbar/navbar";

const Recoverpassword = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Navbar />
      <Changepassword />
    </div>
  );
};

export default Recoverpassword;
